import React, { useMemo } from 'react'

import { useGetCustomerRewardsOrders } from '../../../../lib/orders/hooks/useGetCustomerRewardsOrders'
import { RewardsSourceConfig } from '../../../../lib/rewards/sources'
import QueryFallback from '../QueryFallback'
import RewardsOrdersPageContent from './RewardsOrdersPageContent'

export interface RewardsOrdersPageProps {
  rewardsSource: RewardsSourceConfig
}

const RewardsOrdersPage: React.FC<RewardsOrdersPageProps> = ({ rewardsSource }) => {
  const { filter } = rewardsSource
  const { data, error, loading, fetchMoreOrders, refetch } = useGetCustomerRewardsOrders({ filter })
  const headerText = useMemo(
    () => `${rewardsSource.name} Rewards Order History`,
    [rewardsSource.name],
  )

  return (
    <>
      {!!error && !loading && (
        <>
          <h3>{headerText}</h3>
          <hr />
          <QueryFallback
            buttonText="Retry Loading Orders"
            error={error}
            onRetry={() => refetch()}
          />
        </>
      )}
      <RewardsOrdersPageContent
        data={data}
        loading={loading}
        onLoadMore={fetchMoreOrders}
        rewardsSource={rewardsSource}
      />
    </>
  )
}

export default RewardsOrdersPage
